(function() {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsActivitiesBottomActions', directiveFunc);

    function directiveFunc() {
        return {
            restrict: 'E',
            scope: {
                test: '='
            },
            controller: directiveFuncCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/activities/list-panel/activities-bottom-actions',
            link: directiveLink
        };

        function directiveLink(scope) {
            const vm = scope.vm;
            scope.$watch(function() { return vm.pageData.currentActivityType; }, function() {
                if (typeof vm.refreshPlaceholderSelect === typeof function() {}) {
                    vm.refreshPlaceholderSelect({}, {type: vm.pageData.currentActivityType});
                }
            });
        }
    }

    function directiveFuncCtrl(ActivitiesService, ActionManager, lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.onSelectTemplatePlaceholder = onSelectTemplatePlaceholder;
            vm.onAddAttachmentClick = onAddAttachmentClick;

            init();
        }

        function init() {
            ActivitiesService.sync(vm);
        }

        function onSelectTemplatePlaceholder(label, value) {
            tinymce.activeEditor.insertContent(' <u data="non-editable" data-value="' + value + '">' + label + '</u> ');
        }

        function onAddAttachmentClick() {
            const docLibOptions = lodash.get(vm.pageData, 'options.attachmentOptions', {});
            ActionManager('open-document-library', docLibOptions).then(function(result) {
                result.modal.closed.then(function(res) {
                    if (res !== false) {
                        // add to model
                        if (lodash.has(vm.pageData.inputData.model, 'attachments')) {
                            vm.pageData.inputData.model.attachments = vm.pageData.inputData.model.attachments.concat(res);
                        } else {
                            vm.pageData.inputData.model.attachments = res;
                        }
                    }
                });
            });
        }
    }
})();